import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import AboutSection from '../components/AboutSection';
// import About from '../components/About';
import Features from '../components/Features';
import DriverBenefits from '../components/DriverBenefits';
import DriverWaitlist from '../components/DriverWaitlist';
import DriverFAQ from '../components/DriverFAQ';
import Footer from '../components/Footer';
import FooterEnWithLangSwitch from '../components/FooterEn';

const HomePage: React.FC = () => {
  return (
    <>
      <Hero />
      <AboutSection />

      <DriverBenefits />
      <Features />
      <div id="waitlist">
        <DriverWaitlist />
      </div>
      <DriverFAQ />
      <FooterEnWithLangSwitch />
    </>
  );
};

export default HomePage;